exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "article[data-v-21db5a99]{cursor:pointer}footer[data-v-21db5a99]{border-bottom:1px solid #e4e7ed;color:#909399;font-size:.8rem;margin-bottom:.6rem;padding:.1rem 0;text-align:left}.content[data-v-21db5a99]{opacity:.7}.content[data-v-21db5a99]:hover{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21db5a99","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/articles-teaser.vue
// module id = 8Uzi
// module chunks = 1